module.exports = __webpack_public_path__ + "static/slide3-3f1e660385717154a03eb0c0f2715359.png";